import React from 'react';

export const Announcement = (props) => (
    <svg viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle 
            cx="12.5" 
            cy="12.5" r="11.5" 
            fill="none" 
            stroke="#000" 
        />
        <path 
            d="M10.884 7.1H14.046L13.519 14.869H11.411L10.884 7.1ZM12.465 19.136C12.0003 19.136 11.6093 18.9887 11.292 18.694C10.986 18.388 10.833 18.0197 10.833 17.589C10.833 17.1583 10.986 16.8013 11.292 16.518C11.598 16.2233 11.989 16.076 12.465 16.076C12.941 16.076 13.332 16.2233 13.638 16.518C13.944 16.8013 14.097 17.1583 14.097 17.589C14.097 18.0197 13.9383 18.388 13.621 18.694C13.315 18.9887 12.9297 19.136 12.465 19.136Z" 
            fill="#000" 
        />
    </svg>
)